module.exports = __webpack_public_path__ + "77c5f239d547ca3586759a4de13409f5.svg";